module.exports = __webpack_public_path__ + "static/media/tgle-alma.fdd43ab6.png";